// src/utils/env.js

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default BACKEND_URL;
